"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundSelectList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundSelectList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundSelectList, _super);
    function FundSelectList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金精选';
        _this.code = '106003';
        _this.desc = '基金精选';
        _this.requestParams = new zl_1.FundSelectListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundSelectList;
}(service_1.BaseService));
exports.FundSelectList = FundSelectList;
//# sourceMappingURL=fundSelectList.js.map